const dialog = require('../../../../../components/dialog/dialog')

export function confirmDelete(detail) {
	const action = {
		dest: 'accountreconciliation',
		elem: 'fullcont',
		act: 'deleteFromDialog',
		entity: 'accountreconciliation',
		dbid: detail.dbid,
	}
	dialog.start({
		act: 'show',
		html: {
			title: 'Delete Account Reconciliation?',
			des: 'The selected reconciliations will be deleted and their transactions will return to Pending.',
			bodyHtml: '',
			primary: {
				text: 'Delete',
				class: 'button primary',
				dataDetail: `data-detail='${JSON.stringify({ click: [{ dest: 'ripple' }, { dest: 'dialog', act: 'hide' }, action] })}'`,
			},
			secondary: {
				text: 'Cancel',
				class: 'button secondary button-plain',
				dataDetail: `data-detail='{"click":[{"dest":"ripple"},{"dest":"dialog","act":"hide"}]}'`,
			},
			tertiary: {
				text: '',
				class: '',
				dataDetail: '',
			},
		},
	})
}

export function message(text) {
	dialog.start({
		act: 'show',
		html: {
			title: 'Account Reconciliation',
			des: text,
			bodyHtml: '',
			primary: {
				text: 'Ok',
				class: 'button primary',
				dataDetail: `data-detail='{"click":[{"dest":"ripple"},{"dest":"dialog","act":"hide"}]}'`,
			},
			secondary: {
				text: '',
				class: '',
				dataDetail: '',
			},
			tertiary: {
				text: '',
				class: '',
				dataDetail: '',
			},
		},
	})
}
